//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import StoreCreditRefundsComponent from "../../components/product/storeCreditRefunds/storeCreditRefundsComponent";

export default function StoreCreditRefundsProductPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <NavBarComponent />
                <StoreCreditRefundsComponent />
                <FooterComponent />
            </div>
        </div>
    );
}

